import React, { useEffect, useMemo, useState } from 'react';
import { Cloud, fetchSimpleIcons, renderSimpleIcon } from 'react-icon-cloud';

const slugs = [
  'python',
  'javascript',
  'react',
  'nodedotjs',
  'django',
  'mysql',
  'git',
  'github',
  'visualstudiocode',
  'tailwindcss',
  'laravel',
  'adobeaftereffects',
  'adobepremierepro',
  'adobephotoshop',
  'figma',
  'penpot',
  'mongodb',
  'nextdotjs',
  'pytorch',
  'supabase',
  'firebase',
  'postgresql',
  'postman',
  'nginx',
  'socketdotio',
  'vite'
];

const cloudProps = {
  containerProps: {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      paddingTop: '40px',
      filter: 'saturate(1.5) brightness(1.05)'
    }
  },
  options: {
    clickToFront: 500,
    depth: 1,
    imageScale: 2,
    initial: [0.03, -0.03],
    outlineColour: '#0000',
    reverse: true,
    tooltip: 'native',
    tooltipDelay: 0,
    wheelZoom: false,
    maxSpeed: 0.03,
    minSpeed: 0.002
  }
};

const IconSphere = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchSimpleIcons({ slugs }).then((result) => setData(result));
  }, []);

  const renderedIcons = useMemo(
    () =>
      data
        ? Object.values(data.simpleIcons).map((icon) =>
            renderSimpleIcon({
              icon,
              size: 55,
              bgHex: '#202020',
              fallbackHex: '#ffffff',
              minContrastRatio: 1.8,
              aProps: {
                href: undefined,
                onClick: (event) => event.preventDefault()
              }
            })
          )
        : [],
    [data]
  );

  if (!data) {
    return (
      <div style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        Loading 3D Globe...
      </div>
    );
  }

  return <Cloud {...cloudProps}>{renderedIcons}</Cloud>;
};

export default React.memo(IconSphere);
